export const IMAGES_GET_REQUEST = 'app/image-search/IMAGES_GET_REQUEST';
export const IMAGES_GET_SUCCESS = 'app/image-search/IMAGES_GET_SUCCESS';
export const IMAGES_GET_FAILURE = 'app/image-search/IMAGES_GET_FAILURE';

export const IMAGE_SEARCH_RESULTS_CLEAR =
  'app/image-search/IMAGE_SEARCH_RESULTS_CLEAR';
export const IMAGE_SEARCH_RESULTS_CLEAR_ALL =
  'app/image-search/IMAGE_SEARCH_RESULTS_CLEAR_ALL';
